module.exports = __webpack_public_path__ + "img/posh.7ddd2c04.svg";